module.exports = __webpack_public_path__ + "static/media/mini_truck.088aa576.svg";